// extracted by mini-css-extract-plugin
export default {"container":"ControlFeatures_container__Z6NO4","wrapper":"ControlFeatures_wrapper__xSGxU","phraseBox":"ControlFeatures_phraseBox__HaDDh","icon":"ControlFeatures_icon__er6qP"};